import { useState } from 'react';
import { BannerPreviewSection } from '@/components/user_catalog/banners/BannerPreviewSection';
import { clampPage } from '@/components/user_catalog/banners/bannerPreview';
import { useBannerPreviewModel } from '@/components/user_catalog/banners/useBannerPreviewModel';

interface HomePreviewShelfBannerProps {
  /** Banner-kind collections share their id with the banner. */
  collectionId: number;
  /** False keeps the section loading without fetching. */
  enabled?: boolean;
}

/** A banner section in the feed — creatives, not publications. Reuses the
 * banner detail page's section renderer, so both stay in step. */
export const HomePreviewShelfBanner = ({
  collectionId,
  enabled = true,
}: HomePreviewShelfBannerProps) => {
  const { model, isLoading } = useBannerPreviewModel(collectionId, enabled);
  const [page, setPage] = useState(1);

  return (
    <BannerPreviewSection
      model={model}
      selectedPage={clampPage(page, model.entries.length)}
      onSwipe={setPage}
      loading={isLoading}
    />
  );
};
